/**
 * Client for the contact / bug-report Cloudflare Worker. This is the *only*
 * network call CatalogKit makes, and only when the user explicitly submits the
 * contact form or a reviewed bug report. Nothing is sent automatically.
 */

/** Token used by the Turnstile dev fallback when no site key is configured. */
export const DEV_BYPASS_TOKEN = "dev-turnstile-bypass";

/** Worker endpoint; overridable at build time via VITE_CONTACT_ENDPOINT. */
export const CONTACT_ENDPOINT = import.meta.env.VITE_CONTACT_ENDPOINT ?? "/api/contact";

export interface ContactMessage {
  type: "contact";
  name: string;
  email: string;
  subject: string;
  message: string;
  turnstileToken: string;
}

export interface BugReportMessage {
  type: "bug_report";
  report: unknown;
  turnstileToken: string;
}

export type OutboundMessage = ContactMessage | BugReportMessage;

export interface SubmitResult {
  ok: boolean;
  message: string;
}

/** POST a contact message or bug report to the Worker. Never throws. */
export async function submitMessage(payload: OutboundMessage): Promise<SubmitResult> {
  try {
    const response = await fetch(CONTACT_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    let body: { ok?: boolean; message?: string } = {};
    try {
      body = (await response.json()) as typeof body;
    } catch {
      /* non-JSON response */
    }
    if (!response.ok) {
      return { ok: false, message: body.message ?? `Request failed (${response.status}).` };
    }
    return { ok: true, message: body.message ?? "Message sent. Thank you!" };
  } catch {
    return { ok: false, message: "Network error — could not reach the server. Please email us directly." };
  }
}
